export default __webpack_public_path__ + "static/media/iphone-11-pro.39dbe090.png";